import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from './StyledCell.module.scss';

const StyledCell = props => (
    <div className={ props.styles.cellStyling }>{props.value}
    </div>
);

StyledCell.defaultProps = {
    styles: defaultStyles,
    value: ''
};

StyledCell.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string),
    value: PropTypes.string
};

export default StyledCell;
